export default __webpack_public_path__ + "static/media/check-circle.a2c7911e.svg";